<script setup lang="ts">
import { computed } from 'vue';

const props = defineProps<{ name: string }>();

const initials = computed(() => {
   const SPLIT_NAME = props.name.split(' ');
   if (SPLIT_NAME.length === 1) return SPLIT_NAME[0].charAt(0);

   return SPLIT_NAME.map((n) => n.charAt(0))
      .join('')
      .slice(0, 2);
});
</script>
<template>
   <div class="initials">
      {{ initials }}
   </div>
</template>
<style lang="scss" scoped>
.initials {
   display: flex;
   flex-direction: row;
   justify-content: center;
   align-items: center;

   width: 35px;
   height: 35px;

   border-radius: 50%;

   background-color: var(--nxt-plan-main);
   color: var(--nxt-white);

   font-size: var(--nxt-font-large);
   font-weight: var(--nxt-font-bold);
}
</style>
